/**
 * Survey status operations that can be performed on a space lite record.
 *
 * Sign off and unlock are inverse operations on the same survey status, so
 * they are handled by this single plugin, but each of them tracks its own
 * confirmation, submission and error status.
 */
export enum Operation {
  SignOff = 'signOff',
  Unlock = 'unlock',
}
